module.exports = __webpack_public_path__ + "static/media/note4.20db1e6a.png";